import { BIOME_IDS } from '../data/biomes.js';
import { BIOME_WEATHER, WEATHER_RAMP_MS } from '../data/weather.js';
import { seededRng } from './random.js';
/** The strength changes by steps: a few redraws per ramp, never one per frame. */
export const WEATHER_STEPS = 8;
/** How far ahead a clear sky looks for its end: past this, it says the horizon. */
const LOOKAHEAD_WINDOWS = 64;
function stepped(fraction) {
    return Math.round(Math.min(1, Math.max(0, fraction)) * WEATHER_STEPS) / WEATHER_STEPS;
}
/** Whether a biome's window holds a spell: a roll seeded by the window and the biome. */
function holdsSpell(biome, window) {
    const salt = Math.imul(BIOME_IDS.indexOf(biome) + 1, 0x9e3779b1);
    return seededRng((window ^ salt) >>> 0)() < BIOME_WEATHER[biome].chance;
}
export function weatherOf(biome, now) {
    const { kind, everyMs, lastsMs, offsetMs } = BIOME_WEATHER[biome];
    const window = Math.floor((now - offsetMs) / everyMs);
    const start = window * everyMs + offsetMs;
    const end = start + lastsMs;
    if (now < end && holdsSpell(biome, window)) {
        const ramp = Math.min(now - start, end - now) / WEATHER_RAMP_MS;
        return { kind, strength: Math.max(1 / WEATHER_STEPS, stepped(ramp)), endsAt: end };
    }
    for (let next = window + 1; next <= window + LOOKAHEAD_WINDOWS; next += 1) {
        if (holdsSpell(biome, next))
            return { kind: 'clear', strength: 0, endsAt: next * everyMs + offsetMs };
    }
    return {
        kind: 'clear',
        strength: 0,
        endsAt: (window + LOOKAHEAD_WINDOWS + 1) * everyMs + offsetMs,
    };
}
//# sourceMappingURL=weather.js.map